export enum Labels {
  Hide = 'Hide',
  Show = 'Show',
  ExpandScreen = 'Expand Screen',
  SideBySide = 'Side by Side',
  SwitchScreen = 'Switch Screen'
}
